var notificacao = function () {

    var sucesso = function (mensagem) {
        if (mensagem == undefined) {
            mensagem = "Operação realizada com sucesso.";
        }

        $.notify(mensagem, { pos: "top-right", status: "success" });
    };

    var erro = function (mensagem) {

        if (mensagem == undefined) {
            mensagem = "Erro! Verifique a operação.";
        }

        $.notify(mensagem, { pos: "top-right", status: "danger" });
    };

    var alerta = function (mensagem) {

        if (mensagem == undefined) {
            mensagem = "Atenção! Verifique a operação.";
        }

        $.notify(mensagem, { pos: "top-right", status: "warning" });
    };

    var erroAjax = function(jqXHR) {
        var mensagemRetorno = "";
        if (jqXHR.status === 0) {
            mensagemRetorno = "Não conectado Verifique rede.";
        } else if (jqXHR.status === 404) {
            mensagemRetorno = "Página solicitada não encontrada. [404]";
        } else if (jqXHR.status === 500) {
            mensagemRetorno = "Erro interno do servidor [500].";
        } else {
            mensagemRetorno = "Erro não capturado " + jqXHR.responseText;
        }
        return mensagemRetorno;
    };

    return {
        sucesso: sucesso,
        erro: erro,
        erroAjax: erroAjax,
        alerta: alerta
    }
}();